// Hook usunięcia pozycji – DELETE /sales-crm/clients/:cid/offers/:oid/positions/:pid

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteSalesCrmOfferPosition = (
  clientId: number,
  offerId: string,
  positionId: number
): Promise<IResponse> =>
  axios.delete(`/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}`);

export const useDeleteSalesCrmOfferPosition = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<IResponse, IError, number>
) =>
  useMutation(
    (positionId: number) => deleteSalesCrmOfferPosition(clientId, offerId, positionId),
    options
  );
